<template>
  <v-row justify="center">
    <v-col>
      <h4 class="order-tip__header">Tip</h4>
      <v-row no-gutters>
        <v-col class="order-tip__thank-you">
          Say thank you! 100% of your tips go directly to your driver
        </v-col>
      </v-row>

      <section class="order-tip__button__wrapper col-lg-9">
        <v-btn
          class="order-tip__button"
          :color="activeTipColor($options.Tips.ten)"
          rounded
          @click.stop="setSelectedTip($options.Tips.ten)"
        >
          <div class="checkout-label-font-size text-capitalize">
            {{ $options.Tips.ten.text }}
          </div>
        </v-btn>

        <v-btn
          class="order-tip__button"
          :color="activeTipColor($options.Tips.fifteen)"
          rounded
          @click.stop="setSelectedTip($options.Tips.fifteen)"
        >
          <div class="checkout-label-font-size text-capitalize">
            {{ $options.Tips.fifteen.text }}
          </div>
        </v-btn>

        <v-btn
          class="order-tip__button"
          :color="activeTipColor($options.Tips.twenty)"
          rounded
          @click.stop="setSelectedTip($options.Tips.twenty)"
        >
          <div class="checkout-label-font-size text-capitalize">
            {{ $options.Tips.twenty.text }}
          </div>
        </v-btn>

        <v-btn
          class="order-tip__button"
          :color="activeTipColor($options.Tips.other)"
          rounded
          @click.stop="setSelectedTip($options.Tips.other)"
        >
          <div class="checkout-label-font-size text-capitalize">
            {{ $options.Tips.other.text }}
          </div>
        </v-btn>
      </section>

      <section class="order-tip__your-tip__wrapper">
        <div class="empty"></div>
        <h4 class="order-tip__your-tip__header">Your tip</h4>
        <CurrencyInput
          style="max-width: 150px"
          :disabled="selectedTip !== $options.Tips.other"
          :modelValue="tipText"
          :setInput="setTipAmountOnChange"
        />
        <div class="empty"></div>
      </section>
    </v-col>
  </v-row>
</template>

<script>
import CurrencyInput from "@/components/Inputs/Currency.vue";
import { mapState } from "vuex";
import { Tips } from "@/types/tips";

export default {
  name: "OrderTips",
  components: {
    CurrencyInput,
  },
  computed: {
    ...mapState({
      order: (state) => state.orders.order,
    }),
    tipTypePercentageSelected() {
      return this.selectedTip !== Tips.other;
    },
  },
  Tips,
  methods: {
    activeTipColor(tip) {
      if (!tip) return "";
      return tip.text === this.selectedTip?.text ? "primary" : "";
    },
  },
  props: {
    selectedTip: Object,
    setSelectedTip: Function,
    setTipAmountOnChange: Function,
    tipText: String,
  },
};
</script>

<style lang="scss" scoped>
.order-tip {
  &__header {
    margin: 28px 0 24px 0;
    text-align: center;
    font-weight: normal;
  }

  &__thank-you {
    font-size: 12px;
    text-align: center;
  }

  &__button {
    height: 50px !important;
    width: 80px;

    &__wrapper {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      max-width: 75%;
      margin: 16px auto;
    }
  }

  &__your-tip {
    &__wrapper {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      max-width: 75%;
      margin: 0 auto 56px;
    }

    &__header {
      font-weight: normal;
      font-size: 14px;
      margin-right: 24px;
      justify-self: end;
      align-self: center;
    }

    & label {
      display: none;
    }

    &__input {
      width: 100px;
    }
  }
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .order-tip {
    &__header {
      font-size: 22px;
      margin: 28px 0 24px 0;
      text-align: center;
      font-weight: normal;
    }

    &__thank-you {
      font-size: 16px;
    }

    &__button {
      width: 90px;
      height: 48px;

      &__wrapper {
        max-width: 100%;
        margin: auto;
        padding: 0;
      }
    }

    &__your-tip {
      &__wrapper {
        max-width: 100%;
        margin: auto;
      }

      &__header {
        margin-right: 16px;
      }
    }
  }
}

@media #{map-get($display-breakpoints, 'md-and-up')} {
  .order-tip {
    &__button {
      width: 147.3px;
    }
  }
}
</style>
